import { queryOptions } from '@tanstack/react-query';

import { getSignalList } from './get-signal-list';

export const signalQueryKeys = {
  all: ['signal'] as const,
  lists: () => [...signalQueryKeys.all, 'list'] as const,
  list: (workspaceId: string) =>
    [...signalQueryKeys.lists(), workspaceId] as const,
};

/**
 * Signal 목록 조회 queryOptions
 */
export function signalListQueryOptions({
  workspaceId,
}: {
  workspaceId: string;
}) {
  return queryOptions({
    queryKey: signalQueryKeys.list(workspaceId),
    queryFn: () => getSignalList({ workspace_id: workspaceId }),
  });
}
